import React from 'react';
import IdleTimer from 'react-idle-timer';
import IdleModal from './IdleModal';
import {useBoolean} from '../../utils/hooks';

/**
 * IdleHandler
 * This will show IdleModal every {timeout} seconds without user action (mouse move, keyboard click, etc...)
 * For more information, read documentation of react-idle-timer
 */
function IdleHandler() {
    // const idleTimerRef = useRef(null);
    const [isIdleModalOpen, openIdalModal, closeIdalModal] = useBoolean(false);

    // const onAction = (e) => {
    //     console.log('Action', e);
    // }

    // const onActive = e => {
    //     console.log('User is active', e);
    //     console.log('time remaining', idleTimerRef.current.getRemainingTime());
    // }

    const onIdle = e => {
        // console.log('user is idle', e);
        openIdalModal();
        // console.log('last active', idleTimerRef.current.getLastActiveTime());
    }

    return (
        <>
        <IdleTimer
            // ref={ref => idleTimerRef.current = ref}
            element={document.getElementById('root')}
            // onActive={onActive}
            // onAction={onAction}
            onIdle={onIdle}
            timeout={1000*60*15}
            debounce={20}
        />
        <IdleModal
            isOpen={isIdleModalOpen}
            onRequestClose={closeIdalModal}
        />
        </>
    )
}

export default IdleHandler;